/**
 * Check if a given object implements the DisplayInfo interface.
 */
export function instanceOfDisplayInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function DisplayInfoFromJSON(json) {
    return DisplayInfoFromJSONTyped(json, false);
}
export function DisplayInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
    };
}
export function DisplayInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
    };
}
